import moment from 'moment';
import { DAPI_HOST } from '../../config';
import {
  EXTERNAL_SLOT_DATE_FETCH_FORMAT,
  FETCH_SLOTS_INTERVAL_DAYS,
} from '~/components/ProviderGroup/constants';
import { isEmpty } from '../util/empty';

const PROVIDER_FIELDS = [
  'id',
  'locations',
  'first_name',
  'last_name',
  'biography',
  'title',
  'image_links',
  'specialties',
  'rating_solv',
  'rating_solv_count',
  'top_review_json',
  'rating_wait_time',
  'rating_bedside_manner',
  'rating_staff_friendliness',
  'rating_facility_cleanliness',
];

const SLOTS = 'slots';

const EXTERNAL_PROVIDER_FIELDS = [SLOTS];

const getProviderUrl = (
  providerId: string,
  includeExternal: boolean = true,
  startDate: string = moment().format(EXTERNAL_SLOT_DATE_FETCH_FORMAT),
  endDate: string = moment()
    .add(FETCH_SLOTS_INTERVAL_DAYS, 'day')
    .format(EXTERNAL_SLOT_DATE_FETCH_FORMAT),
  fields: string[] = PROVIDER_FIELDS
) => {
  return includeExternal
    ? `${DAPI_HOST}/v1/providers/${providerId}?fields=${[
        ...fields,
        ...EXTERNAL_PROVIDER_FIELDS,
      ].join(',')}&external_slot_start_date=${startDate}&external_slot_end_date=${endDate}`
    : `${DAPI_HOST}/v1/providers/${providerId}?fields=${fields.join(',')}`;
};

const getProvidersUrl = ({
  providerIds,
  specialties,
  groupId,
  locationId,
  fields = PROVIDER_FIELDS,
  startDate = moment().format(EXTERNAL_SLOT_DATE_FETCH_FORMAT),
  endDate = moment().add(FETCH_SLOTS_INTERVAL_DAYS, 'day').format(EXTERNAL_SLOT_DATE_FETCH_FORMAT),
}: {
  providerIds?: string[];
  specialties?: string[];
  groupId?: string;
  locationId?: string;
  fields?: string[];
  startDate?: string;
  endDate?: string;
}) => {
  let url = `${DAPI_HOST}/v2/providers?fields=${fields.join(',')}`;
  if (!isEmpty(specialties)) {
    const specialtyFilters: string[] = [];
    specialties?.forEach((specialty) => specialtyFilters.push(`specialties.name:${specialty}`));
    url += `&filters=${specialtyFilters.join(',')}`;
  }

  if (!isEmpty(groupId)) {
    url += `&group_ids=${[groupId]}`;
  }

  if (!isEmpty(locationId)) {
    url += `&location_ids=${[locationId]}`;
  }

  if (!isEmpty(providerIds)) {
    url += `&provider_ids=${providerIds}`;
  }

  if (fields.includes(SLOTS))
    url += `&external_slot_start_date=${startDate}&external_slot_end_date=${endDate}`;

  // TODO add real pagination logic
  url += '&limit=100';
  return url;
};

const getProviderRatingsUrl = (providerIds: string[], page: number) => {
  const providerIdsString = providerIds.join(',');
  const filtersString = `provider_ids=${providerIdsString}&page=${page}`;
  return `${DAPI_HOST}/v1/providers/reviews?${filtersString}`;
};

export { PROVIDER_FIELDS, getProviderUrl, getProvidersUrl, getProviderRatingsUrl };
